const browserHost = (state) => state.getIn(['browser', 'location', 'host'], '');

export default browserHost;
